<template>
  <LazyLoader api-key="giftsTopBoard" @init="fetchData">
    <div v-if="allList.length" class="clearfix">
      <div class="top-list">
        <div v-if="firstGame.id" class="game-item">
          <img
            :src="firstGame.banner"
            alt="游戏图片"
            @click="
              $util.clickStat(`LBZX/TJ1`, `礼包中心/推荐1`)
              $util.goGiftDetail(firstGame)
            "
          />
          <i class="rang-icon" data-content="本周最热"></i>
          <div class="bar">
            <span
              @click="
                $util.clickStat(`LBZX/TJ1`, `礼包中心/推荐1`)
                $util.goGiftDetail(firstGame)
              "
              >{{ firstGame.title }}</span
            >
            <i :class="`icon-${firstGame.flag}-cn`"></i>
            <button
              @click="
                $util.clickStat(`LBZX/TJ1`, `礼包中心/推荐1`)
                getGift(firstGame)
              "
            >
              立即领取
            </button>
          </div>
        </div>
      </div>
      <div class="top-list">
        <div
          v-for="(item, i) in secondList"
          :key="item.id"
          :class="['top', 'bottom'][i]"
        >
          <div class="game-item">
            <img
              :src="item.image"
              alt="游戏图片"
              @click="
                $util.clickStat(`LBZX/TJ${i + 2}`, `礼包中心/推荐${i + 2}`)
                $util.goGiftDetail(item)
              "
            />
            <i class="rang-icon" data-content="本周最热"></i>
            <div class="bar">
              <span
                @click="
                  $util.clickStat(`LBZX/TJ${i + 2}`, `礼包中心/推荐${i + 2}`)
                  $util.goGiftDetail(item)
                "
                >{{ item.title }}</span
              >
              <i :class="`icon-${item.flag}-cn`"></i>
              <button
                @click="
                  $util.clickStat(`LBZX/TJ${i + 2}`, `礼包中心/推荐${i + 2}`)
                  getGift(item)
                "
              >
                立即领取
              </button>
            </div>
          </div>
        </div>
      </div>
      <TopList3
        :list="thirdList"
        :stat-params="statParams"
        @get-gift="getGift"
      />
    </div>
    <template v-slot:skeleton="{ error, loading }">
      <div class="clearfix">
        <div class="top-list">
          <div class="game-item">
            <Skeleton :error="error" :loading="loading" @retry="fetchData" />
          </div>
        </div>
        <div class="top-list">
          <div class="top">
            <div class="game-item">
              <Skeleton :error="error" :loading="loading" @retry="fetchData" />
            </div>
          </div>
          <div class="bottom">
            <div class="game-item">
              <Skeleton :error="error" :loading="loading" @retry="fetchData" />
            </div>
          </div>
        </div>
        <div class="top-list list-num3">
          <div class="title3">热门礼包</div>
        </div>
      </div>
    </template>
  </LazyLoader>
</template>

<script>
import { mapState } from 'vuex'
import TopList3 from '~/components/gifts/TopList3'
export default {
  name: 'GiftsTopBoard',
  components: {
    TopList3
  },
  data() {
    return {
      statParams: {
        eid: 'LBZX/RMLB',
        eid_desc: '礼包中心/热门礼包'
      }
    }
  },
  computed: {
    ...mapState('gifts', ['topBoardList', 'boardList']),
    allList() {
      return [...this.topBoardList, ...this.boardList]
    },
    firstGame() {
      return this.topBoardList[0] || {}
    },
    secondList() {
      return this.topBoardList.slice(1, 3)
    },
    thirdList() {
      return this.boardList.slice(0, 5)
    }
  },
  methods: {
    getGift(item) {
      this.$util.goGiftDetail(item)
    },
    fetchData() {
      this.$store.dispatch('gifts/fetchBoardData', { type: 5 })
      this.$store.dispatch('gifts/fetchBoardData', { type: 6 })
    }
  }
}
</script>
